import React, { useEffect, useState } from "react";
import type { FormProps } from 'antd';
import { Link } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import {useParams} from 'react-router-dom'
import { Button, Divider, Checkbox, Form, Input, Select, InputNumber, message, notification } from 'antd';
type FieldType = {
    login?: string;
    lastname?: string;
    firstname?: string;
    email?: string;
};





const AddGuide: React.FC = () => {
    const {id} = useParams();
    const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
        FetchWithAuth(`/api/content/create/user/${id}`, {
            method: "POST",
            body: JSON.stringify(values),
        }).then(res => {
            if (!res.error) {
                message.success({
                    content: '提交成功'
                });
            } else {
                notification.error({ message: res.data.message });
            }
        })
    };

    const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <div>
            <div className="header-container">
                <h2>添加导游</h2>
            </div>
            <div>
                <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item<FieldType>
                        label="用户名"
                        name="login"
                        rules={[{ required: true, message: '请输入用户名' }]}
                    >
                        <Input  placeholder="请输入用户名"/>
                    </Form.Item>

                    <Form.Item<FieldType>
                        label="密码"
                        name="password"
                    >
                        <Input.Password  placeholder="请输入密码"/ >
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="确认密码"
                        name="confirm"
                        dependencies={['password']}
                        rules={[
                            {
                              required: false,
                              message: '两次密码不一致',
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('两次密码不一致'));
                              },
                            }),
                          ]}
                    >
                        <Input.Password  placeholder="请确认密码"/>
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="姓氏"
                        name="lastname"
                        rules={[{ required: true, message: '请输入姓氏' }]}
                    >
                       <Input  placeholder="请输入姓氏"/>
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="名字"
                        name="firstname"
                        rules={[{ required: true, message: '请输入名字' }]}
                    >
                        <Input  placeholder="请输入名字"/>
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="邮箱"
                        name="email"
                        rules={[{ required: true, message: '请输入邮箱' }]}
                    >
                        <Input  placeholder="请输入邮箱"/>
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            提交
                        </Button>
                        <Link to={"/guide/list"}>
                            {" "}
                            <Button style={{ marginLeft: '12px' }}>
                                返回
                            </Button>
                        </Link>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )

}

export default AddGuide